module.exports = __webpack_public_path__ + "assets/5c9c2aa778e22c908c39a1d5483ec10e.png";